"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-upload", _vm._g(_vm._b({
    ref: "upload",
    attrs: {
      name: "file",
      multiple: _vm.limit !== 1 && _vm.multiple,
      "list-type": _vm.listType,
      "before-upload": _vm.beforeUpload,
      "default-file-list": _vm.defaultFileList,
      "file-list": _vm.fileList,
      accept: _vm.accept
    },
    on: {
      change: _vm.onChange,
      reject: _vm.onReject
    }
  }, "a-upload", _vm.uploadAttrs, false), _vm.$listeners), [!_vm.hideEntry ? [_vm._t("default", function () {
    return [_vm.listType === "picture-card" ? _c("div", [_c("a-icon", {
      attrs: {
        type: "plus"
      }
    }), _c("div", {
      staticClass: "ant-upload-text"
    }, [_vm._v("点击上传")])], 1) : _c("a-button", {
      attrs: {
        type: "dashed"
      }
    }, [_vm._v("点击或拖拽文件上传"), _c("a-icon", {
      attrs: {
        type: "upload"
      }
    })], 1)];
  })] : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;